import { ReactComponent as DonationHistoryBanner } from "./donnation-history-banner.svg";
import { jsx as _jsx } from "react/jsx-runtime";
export default props => /*#__PURE__*/_jsx(DonationHistoryBanner, {
  ...props
});